module.exports = __webpack_public_path__ + "img/egg_flowers.cd0243a9.svg";